import { Record } from 'immutable';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

const AppUploadingRecordClass = Record({
  id: null,
  displayName: null,
  error: null,
  status: appStorageConstants.APP_UPLOAD_STATUS.UPLOADING,
  progress: 0,
  fileSize: null,
});

class AppUploadingRecord extends AppUploadingRecordClass {
  getPrettyProgress() {
    return `${this.progress * 100}%`;
  }
}

export {
  AppUploadingRecord,
};
